export default {
    beforeMount(el, binding) {
        let pressTimer = null

        const handler = () => {
            binding.value()
        }

        const start = () => {
            // 500ms 触发长按，可自行调整
            pressTimer = setTimeout(handler, 500)
        }

        const cancel = () => {
            if (pressTimer) {
                clearTimeout(pressTimer)
                pressTimer = null
            }
        }

        el.addEventListener("mousedown", start)
        el.addEventListener("touchstart", start)

        el.addEventListener("mouseup", cancel)
        el.addEventListener("mouseleave", cancel)
        el.addEventListener("touchend", cancel)
        el.addEventListener("touchcancel", cancel)
    }
}